import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

interface SendIconProps {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

const SendIcon: React.FC<SendIconProps> = ({ color, width = 16, height = 16, className }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorPrimary;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.7078 1.42709C15.7078 1.42709 15.7078 1.43412 15.7078 1.43764L11.6156 14.9334C11.5536 15.1526 11.4261 15.3476 11.2502 15.4923C11.0742 15.6369 10.8582 15.7243 10.6312 15.7427C10.5988 15.7455 10.5665 15.7469 10.5342 15.7469C10.3214 15.7476 10.1129 15.6874 9.93322 15.5734C9.75356 15.4594 9.61027 15.2964 9.52025 15.1036L6.96088 9.85123C6.93527 9.79859 6.92672 9.73928 6.93643 9.68155C6.94613 9.62383 6.97361 9.57057 7.01502 9.5292L11.0875 5.4567C11.1886 5.35035 11.2441 5.20874 11.2422 5.06206C11.2403 4.91538 11.1812 4.77524 11.0775 4.67152C10.9737 4.56779 10.8336 4.50869 10.6869 4.50681C10.5402 4.50493 10.3986 4.56043 10.2923 4.66146L6.21768 8.73396C6.17631 8.77538 6.12305 8.80285 6.06532 8.81256C6.0076 8.82226 5.94828 8.81371 5.89565 8.7881L0.63838 6.22943C0.4328 6.1308 0.262042 5.97204 0.148735 5.77417C0.0354285 5.5763 -0.0150785 5.34867 0.00390759 5.12145C0.0228936 4.89422 0.110476 4.67813 0.25505 4.50181C0.399623 4.32549 0.594361 4.19726 0.813458 4.13412L14.3092 0.0419327H14.3198C14.5119 -0.0120522 14.715 -0.0139448 14.9081 0.0364492C15.1012 0.0868431 15.2775 0.187709 15.4188 0.328699C15.56 0.469688 15.6613 0.645724 15.712 0.838747C15.7628 1.03177 15.7613 1.23483 15.7078 1.42709Z"
        fill={currentColor}
      />
    </svg>
  );
};

export default SendIcon;
